import { BseDto } from "../../autogen/bff-api";

export const eventIsClosed = (event: BseDto): boolean => {
  return event.status === "Closed";
};
